import {
  REQUEST_PREREQUISITES,
  RECEIVE_PREREQUISITES,
  FORGET_TOKEN
} from "../actions/prerequisites";
import { RECEIVE_PROFILE } from "../actions/profile";
import { HTTP_ERROR } from "../actions/error";

const checkValidConfig = (config, currentStatus) => {
  if (
    !(
      currentStatus === "" ||
      currentStatus === "success" ||
      currentStatus === "loading"
    )
  ) {
    return currentStatus;
  }
  if (!config) {
    return "Server unreachable";
  }
  if (!config.ONBOARDING) {
    return "Authentication service unavailable";
  }
  if (!config.APISERVER) {
    return "API unavailable";
  }
  return "success";
};

const checkValidUser = (user, currentStatus) => {
  if (
    !(
      currentStatus === "" ||
      currentStatus === "success" ||
      currentStatus === "loading"
    )
  ) {
    return currentStatus;
  }

  if (!user) {
    return "Can't get profile";
  }
  if (user.role !== 0) {
    return "Permission denied";
  }
  if (user.status !== "active") {
    return "User not active";
  }
  return "success";
};

/*
Eventually we'll need to handle other http errors here

*/
const checkError = (error, currentStatus) => {
  if (error.message === "UNAUTHORIZED") {
    return "Unauthorized request";
  }
  return error.message;
};

export default function prerequisites(
  state = { status: "", config: {}, webtoken: "" },
  action
) {
  switch (action.type) {
    case REQUEST_PREREQUISITES:
      return Object.assign({}, state, {
        status: "loading",
        webtoken: action.token
      });
    case RECEIVE_PREREQUISITES:
      return Object.assign({}, state, {
        config: action.config,
        webtoken: action.webtoken,
        status: checkValidConfig(action.config, state.status)
      });
    case RECEIVE_PROFILE:
      return Object.assign({}, state, {
        status: checkValidUser(action.user, state.status)
      });

    case HTTP_ERROR:
      return Object.assign({}, state, {
        status: checkError(action.error, state.status)
      });

    case FORGET_TOKEN:
      return Object.assign({}, state, {
        webtoken: "forget"
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/prerequisites.js